// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_quiz__lVxaT {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  background-color: rgb(247, 246, 255);
  overflow: hidden;
  align-items: center;
}
.style_quiz__title__KjnRl {
  max-width: 300px;
  text-wrap: wrap;
  text-align: center;
  margin-bottom: 12px;
}
.style_quiz__description__eMIjz {
  max-width: 220px;
  text-wrap: wrap;
  text-align: center;
}
.style_quiz__answers__ZWeFv {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  width: 100%;
}
.style_quiz__submit__EReo2 {
  position: absolute;
  width: 80vw;
  top: 85%;
}

.style_answer__TDC7T {
  padding: 8px 16px 8px 8px;
  border: 2px solid #c3b5f9;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: rgb(27, 27, 27);
  font-weight: 700;
  font-size: 1.6rem;
}
.style_answer__selected__2F-ft {
  border-color: rgb(117, 83, 240);
  background: rgb(117, 83, 240);
  color: rgb(255, 255, 255);
}
.style_answer__TDC7T img {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/earn/tasks/cuberium-survey/cuberium-survey-quiz/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAEE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAEE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;AADJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AADJ;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBC9CY;ED+CZ,gBAAA;EACA,iBAAA;AAFF;AAGE;EACE,+BCpDG;EDqDH,6BCrDG;EDsDH,yBCjDI;ADgDR;AAGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AADJ","sourcesContent":["@import 'public/assets/colors';\n\n.quiz {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999;\n  display: flex;\n  padding: 24px 16px;\n  flex-direction: column;\n  background-color: rgba(247, 246, 255, 1);\n  overflow: hidden;\n  align-items: center;\n  &__title {\n    max-width: 300px;\n    text-wrap: wrap;\n    text-align: center;\n    margin-bottom: 12px;\n  }\n  &__description {\n    max-width: 220px;\n    text-wrap: wrap;\n    text-align: center;\n  }\n\n  &__answers {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 12px;\n    width: 100%;\n  }\n  &__submit {\n    position: absolute;\n    width: 80vw;\n    top: 85%;\n  }\n}\n\n.answer {\n  padding: 8px 16px 8px 8px;\n  border: 2px solid #c3b5f9;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  color: $black-extra;\n  font-weight: 700;\n  font-size: 1.6rem;\n  &__selected {\n    border-color: $main;\n    background: $main;\n    color: $white;\n  }\n  img {\n    width: 50px;\n    height: 50px;\n    border-radius: 50px;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quiz": `style_quiz__lVxaT`,
	"quiz__title": `style_quiz__title__KjnRl`,
	"quiz__description": `style_quiz__description__eMIjz`,
	"quiz__answers": `style_quiz__answers__ZWeFv`,
	"quiz__submit": `style_quiz__submit__EReo2`,
	"answer": `style_answer__TDC7T`,
	"answer__selected": `style_answer__selected__2F-ft`
};
export default ___CSS_LOADER_EXPORT___;
